<template>
  <div class="expert">
    <div style="width: 1200px; margin: 0 auto">
      <div style="width: 100%; height: 50px"></div>
      <div
        style="
          line-height: 26px;
          font-size: 26px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: #000000;
        "
      >
        专家库<span
          style="
            line-height: 18px;
            font-size: 18px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
            margin-left: 10px;
          "
          >Expert&nbsp;Library</span
        >
      </div>
      <div
        style="width: 54px; height: 2px; background: #3476c1; margin-top: 20px"
      ></div>
      <div style="width: 100%; height: 30px"></div>
      <!--  -->
      <el-carousel height="504px" :autoplay="false" indicator-position="none">
        <el-carousel-item v-for="(item, index) in expertList" :key="index">
          <div style="display: flex; justify-content: space-around">
            <div
              @click="toExpertDetail(items.id)"
              v-for="items in item"
              :key="items.homeImg"
              style="width: 380px; height: 498px"
              class="export-list-box"
            >
              <div style="width: 380px; height: 320px;overflow:hidden">
                <img
                class="hover"
                  :src="items.homeImg"
                  alt=""
                  style="width: 380px; height: 320px"
                />
              </div>
              <div style="padding: 20px; height: 178px; box-sizing: border-box;background-color:#fff;">
                <p
                  style="
                    height: 19px;
                    font-size: 18px;
                    font-weight: bold;
                    font-family: Microsoft YaHei;
                    color: #333333;
                    line-height: 19px;
                    text-overflow: ellipsis;
                    width:400px
                  "
                  class="export-list-p"
                >
                  {{ items.realName }}
                  <span
                    style="
                      font-size: 16px;
                      font-family: Microsoft YaHei;
                      color: #333333;
                      line-height: 19px;
                      margin-left: 10px;
                      font-weight: 400;
                      
                    "
                  >{{items.dutiesName}}</span>
                </p>
                <div style="height: 100px; padding-top: 10px">
                  <p
                    style="
                      height: 100px;
                      font-size: 14px;
                      font-family: MicrosoftYaHei;
                      font-weight: 400;
                      line-height: 25px;
                      color: #888888;
                      overflow: hidden;
                      display: -webkit-box;
                      text-overflow: ellipsis;
                      -webkit-line-clamp: 4;
                      -webkit-box-orient: vertical;
                    "
                  >
                    {{ items.remark }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="morezanserve" @click="toMore">查看更多</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "exper",
  data() {
    return {
      expertIndex: 0, //专家库
      expertList: [],

      //test
      nowIndex: 0,
      isShow: true,
    };
  },
  computed: {
    //通过计算属性控制nowIndex值，来实现向前向后翻页
    preIndex() {
      if (this.nowIndex === 0) {
        return this.expertList.length - 1;
      } else {
        return this.nowIndex - 1;
      }
    },
    nextIndex() {
      if (this.nowIndex === this.expertList.length - 1) {
        return 0;
      } else {
        return this.nowIndex + 1;
      }
    },
  },
  methods: {
    group(array, subGroupLength) {
      let index = 0;
      let newArray = [];
      while (index < array.length) {
        newArray.push(array.slice(index, (index += subGroupLength)));
      }
      return newArray;
    },
    toExpertDetail(id) {
      sessionStorage.setItem("tabIndex", 6);
      this.$router.push({
        path: "/expertDetail",
        query: {
          id,
        },
      });
    },
    toMore() {
      sessionStorage.setItem("tabIndex", 6);
      this.$router.push("/expert");
    },
    expertItemFn(s) {
      this.expertIndex = s;
    },
    goto(index) {
      this.isShow = false;
      //延迟10ms执行下一步
      setTimeout(() => {
        this.isShow = true;
        this.nowIndex = index;
      }, 10);
    },
    invIndex() {
      this.invId = setInterval(() => {
        // console.log(123);
        this.goto(this.nextIndex);
      }, 4000);
    },
    cleanInv() {
      clearInterval(this.invId); //清除自动轮播
    },
  },
  created() {
    //专家
    this.$axios
      .post("/v1/cloud/common/expert", {
        pageSize: 6,
      })
      .then(({ data }) => {
        if (data) {
          let arr = this.group(data, 3);
         let reg = new RegExp("<br/>","g")
          arr.forEach(item => {
            item.forEach(i => {
              
              i.remark = i.remark.replace(reg, "")
            })
          })
          this.expertList = arr
        }
      });
  },
  mounted() {
    this.invIndex(); //自动轮播
  },
};
</script>

<style scoped lang="less">
img.hover {
  transition: all 1s
}
img.hover:hover {
  transition: all 1.5s;
  transform: scale(1.3);
}
.export-list-box {
  box-shadow: 0px 0px 10px 0px rgba(207, 206, 206, 0.51);
}


.export-list-box:hover .export-list-p{
  color: #3476C1 !important;
}
.export-list-box:hover .export-list-p span{
  color: #3476C1 !important;
}
.morezanserve {
  margin: 40px auto 0;
  width: 150px;
  height: 40px;
  border: 1px solid #5fc0e4;
  border-radius: 3px;
  line-height: 40px;
  color: #5fc0e4;
  box-sizing: border-box;
  text-indent: 34px;
  background-image: url("../../static/common/morezan.png");
  background-size: 15px 15px;
  background-repeat: no-repeat;
  background-position: 101px 12px;
  cursor: pointer;
}
.morezanserve:hover {
    background-color: #5FC0E4;
    background-image: url('../../static/common/morezan1.png');
    color: #fff;
  }
/deep/ .el-carousel__arrow {
  width: 40px;
  height: 50px;
  border-radius: 0;
}
/deep/ .el-carousel__arrow i {
  display: none;
}
/deep/ .el-carousel__arrow--left {
  background-image: url("../../static/home/btnleft.png");
  background-size: 17px 27px;
  background-repeat: no-repeat;
  background-position: 12px 11px;
}
/deep/ .el-carousel__arrow--right {
  background-image: url("../../static/home/btnright.png");
  background-size: 17px 27px;
  background-repeat: no-repeat;
  background-position: 12px 11px;
}
.expert {
  width: 100%;
  height: 830px;
  background: #ffffff;
  .more-btn {
    width: 70px;
    height: 70px;
    line-height: 70px;
    text-align: center;
    border-radius: 50%;
    float: left;
    margin-right: 11px;
    background: rgba(248, 248, 248, 1);
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 12px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    cursor: pointer;
  }
  .more-btn:hover {
    color: #109cf2;
  }
}

.slide-trans-enter-active {
  transition: all 0.5s;
}
.slide-trans-enter {
  transform: translateX(1200px); /*transition不支持用left控制*/
}
.slide-trans-old-leave-active {
  transition: all 0.5s;
  transform: translateX(-1200px);
}
.slide-show {
  position: relative;
  margin: 15px 15px 15px 0;
  width: 1200px;
  height: 452px;
  overflow: hidden;
  margin: 0 auto;
  cursor: pointer;
}
.slide-img {
  width: 100%;
}
// .slide-img img {
//     width: 100%;
//     position: absolute;
//     top: 0;
//     left: 0;
// }
.slide-pages {
  // position: absolute;
  // bottom: 10px;
  // right: 15px;
  width: 200px;
  margin: 0 auto;
}
.slide-pages li {
  display: inline-block;
  padding: 0 10px;
  cursor: pointer;
  color: #fff;
}
.slide-pages li .on {
  text-decoration: underline;
}
</style>